module.exports = __webpack_public_path__ + "img/KIKE.9bf644e6.png";